import _ from "lodash";

export const generateTimeSlots = () => {
  return _.chain()
    .thru(() => {
      return _.range(24);
    })
    .flatMap((i) => {
      const hour = _.padStart(i, 2, "0");
      return [
        `${hour}:00`,
        `${hour}:10`,
        `${hour}:20`,
        `${hour}:30`,
        `${hour}:40`,
        `${hour}:50`,
      ];
    })
    .value();
};
